import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';
import {useParams} from 'react-router-dom';
import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {RecordsTable} from "../tables/RecordsTable.tsx";

export const IndexPage = ({ productId }: { productId?: string }) => {
    const urlProductId = useParams().id;
    const finalProductId = productId || urlProductId;
    
    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader/>}
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordsTable productId={finalProductId!}/>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
